import { Controller } from "stimulus";
import geocode from "utils/geocode";

export default class extends Controller {
  static targets = ["countryCode"];

  async connect() {
    if (!this.hasCountryCodeTarget) return;

    if ((this.countryCodeTarget.value || "").trim().length > 0) return; // don't override existing country

    const geo = await geocode();
    if (!geo) return;

    const country = geo.country ? geo.country.toString().trim() : "";
    if (!country) return;

    const countryCode = this.findCountryCode(country);
    if (!countryCode) return;

    this.countryCodeTarget.value = countryCode;
    // trigger form refresh so the server can re-render dependent fields (state/province)
    this.countryCodeTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  findCountryCode(country) {
    const options = Array.from(this.countryCodeTarget.options || []);

    if (country.length === 2) {
      const code = country.toUpperCase();
      if (options.some((opt) => opt.value === code)) return code;
    }

    const normalized = country.toLowerCase();
    const match = options.find((opt) => (opt.text || "").trim().toLowerCase() === normalized);
    return match?.value || null;
  }
}
